export const colors = {
  white: "#FFFFFF",
  black: "#2C3034",
  blackSecondary: "#6B6661",
  blackTertiary: "#333134",
  orange: "#FDBF1E",
  orangeSecondary: "#FF8736",
  green: "#087164",
  red: "#FF4D4D",
  warning: "#DB8520",
  inform: "#0b5bff",
  blue: "#185EE5",
  grey: "#A3A0A1",
  greyOp05: "rgba(44, 48, 52, 0.50)",
  warningRed: "#D63E3E",
  pink: "#fd84e3",
  telegram: "#48BAF3",

  border: "#CBBBAE",
  borderLowest: "#D9CDCB",
  borderNetwork: "#322A28",
  borderNFT: "#CACACA",

  secondaryText: "#736963",
  textHexagon: "#9C8482",

  surfacePrimary: "#ECDEDD",
  surfaceSecondary: "#F0E6E4",
  surfaceTertiary: "#F3EBE9",
  surfaceQuaternary: "#EBDEDC",
  surfaceOverlay: "rgba(208, 186, 184, 0.34)",
  surfaceHexagon: "#DFCDCD",
  surfaceReMint: "#F6EDEA",
  surfaceScores: "#f9f3f2",
  surfaceNetwork: "#F6EDEA",
  surfaceAchievements: "#F9F3F2",

  level1Background: "#FF8F1E",
  level1Border: "#FFAD3C",
  level1BoxShadow: "#EA7100",

  level2Background: "#56B242",
  level2Border: "#8DDE79",
  level2BoxShadow: "#399028",

  level3Background: "#78B2FB",
  level3Border: "#A0DAFF",
  level3BoxShadow: "#144E97",

  level4Background: "#FF5A5A",
  level4Border: "#FFA0A0",
  level4BoxShadow: "#A80000",

  bluePrimary: "#95acff",

  achievements: {
    divider: "#FDB836",
    holder: "rgb(253, 191, 30)",
    villager: "rgb(252, 232, 35)",
    trader: "rgb(253, 132, 227)",
    winner: "rgb(253, 191, 30)",
    hapiHero: "#FCE923",
    levels: {
      disabled: {
        background: "#CCC4C2",
        border: "#DADBD5",
        boxShadow: "#C6BEBB",
      },
      1: {
        background: "#FFBD1B",
        border: "#FFD35D",
        boxShadow: "#F3B73C",
      },
      2: {
        background: "#FF9D55",
        border: "#febb8a",
        boxShadow: "#f59754",
      },
      3: {
        background: "#af89ff",
        border: "#c8adff",
        boxShadow: "#9a7ee3",
      },
      4: {
        background: "#e788fe",
        border: "#f1aaff",
        boxShadow: "#d88bdb",
      },
    },
  },

  picture: "#B9B0AE",

  button: {
    default: {
      disabledBg: "#CBC6C5",
      disabledText: "#6B6661",
    },
    secondary: {
      bg: "#FFD44C",
      boxShadow: "rgba(252, 232, 35, 0.15)",
    },
  },

  airdrop: {
    bg: "#f3ebea",
    default: "#D9CDCB",
    yellow: "#fdbf1e",
    lightGreen: "rgba(8, 113, 100, 0.10)",
    red: "#FF4444",
    lightRed: "rgba(255, 68, 68, 0.10)",
    progressBarBg: "#C7BAB8",
    progressBarValue: "#FDBF1C",
    congrats: "#fd6333",
  },
};
